import React from 'react';

const Dashboard = ({ 
    accountData, 
    userAccount, 
    formatAddress, 
    activeTab,
    onTabChange,
    children
}) => {
    return (
        <div className="dashboard">
            {children}
        </div>
    );
};

export default Dashboard;